import React from "react";

import { pluralizeWord } from "seneca-common/utils/functions/formatting/pluralize";

import Var from "../Var";

type Props = {
  amount: number;
  item: string;
  es?: boolean;
  hideAmount?: boolean;
};

export default function Plural({ amount, item, es, hideAmount }: Props) {
  return (
    <>
      {hideAmount ? null : <Var pluralize={amount}>{amount}</Var>}{" "}
      {pluralizeWord(amount, item, es)}
    </>
  );
}
